import { scaleToHeight } from '../../../utils/imageUtils.js'
import { objectUrlToBlob, blobToDataUrl, blobToImageSize } from '../../../utils/imageUtils.js'
import store from '../../../redux/store';
import { loadPrintSettings } from "../../../serverREST";

export async function buildCompanyInfo() {
    const prevState = store.getState();
    const hasPrintSettings = prevState.settings.hasPrintSettings;

    if (!hasPrintSettings) {
        await loadPrintSettings();
    }

    const state = store.getState();
    const showCompanyInfo = state.settings.showCompanyInfo
    const showLogoOnLeft = state.settings.showLogoOnLeft;
    const organization = state.settings.organization;
    const companyName = state.settings.companyName;
    const companyTin = state.settings.companyTin;
    const companyAddress = state.settings.companyAddress;
    const companyPhoneNumber = state.settings.companyPhoneNumber;
    const companyLogoObjectUrl = state.settings.companyLogoObjectUrl;

    let companyInfo = [];
    if (showCompanyInfo) {
        const infoStrings = [];
        let LogoDataUrl = null;
        let logoSize = null;

        if (organization) infoStrings.push(organization);
        if (companyName) infoStrings.push(companyName);
        if (companyTin) infoStrings.push('ИНН: ' + companyTin);
        if (companyAddress) infoStrings.push(companyAddress);
        if (companyPhoneNumber) infoStrings.push(companyPhoneNumber);

        if (companyLogoObjectUrl) {
            try {
                const blob = await objectUrlToBlob(companyLogoObjectUrl);
                LogoDataUrl = await blobToDataUrl(blob);
                logoSize = await blobToImageSize(blob);

                console.log('logoSize:', logoSize);
            } catch (error) {
                LogoDataUrl = null;
                logoSize = null;

                console.error('Не удалось загрузить логотип:', error);
            }
        }

        companyInfo = buildCompanyInfoContent(infoStrings, LogoDataUrl, logoSize, showLogoOnLeft);
    }

    return companyInfo;
}

function buildCompanyInfoContent (infoStrings, logoDataUrl, logoSize, logoByLeftSide) {
    const nodes = [];
    const columns = [];
    let infoColumn = null;
    let logoColumn = null;

    const linePadding = 8;
    const lineHeight = 11 + linePadding;
    const infoHeight = infoStrings.length * lineHeight - linePadding / 2;
    const needBuildLogo = logoDataUrl ? true : false;
    const targetLogoHeight = Math.min(Math.max(infoHeight, 55), 100);
    const scaledLogoSize = needBuildLogo ? scaleToHeight(logoSize, targetLogoHeight) : 0;

    if (infoStrings.length) {
        const ml = needBuildLogo && logoByLeftSide ? 10 : 0;

        infoColumn = infoStrings.map((str) => ({ text: str, margin: [ml, 0, 0, 0] }));

        if (infoHeight < scaledLogoSize.height) {
            const mt = (scaledLogoSize.height - infoHeight) / 2;
            infoColumn[0].margin = [ml, mt - linePadding / 2, 0, 0];
        }
    }
    if (needBuildLogo) {
        const mt = infoHeight > targetLogoHeight ? (infoHeight - targetLogoHeight) / 2 : 0
        console.log('infoHeight', infoHeight, 'targetLogoHeight', targetLogoHeight)
        logoColumn = {
            image: logoDataUrl,
            width: scaledLogoSize.width * 0.73,
            height: scaledLogoSize.height * 0.73,
            margin: [0, mt, 0, 0],
            // margin: [0, linePadding / 2 + mt, 0, 0],
        };

    }

    if (logoByLeftSide && logoColumn) {
        columns.push(logoColumn);
    }
    if (infoColumn) {
        columns.push(infoColumn);
    }
    if (!logoByLeftSide && logoColumn) {
        columns.push(logoColumn);
    }

    if (columns.length) {
        nodes.push({
            columns: columns,
            margin: [0, 0, 0, 10],
        });
        // nodes.push({
        //     canvas: [
        //         {
        //             type: 'line',
        //             x1: 0 - 40 + 5,
        //             y1: 5,
        //             x2: 595.276 - 40 - 5,
        //             y2: 5,
        //             lineWidth: 1,
        //         },
        //     ],
        //     margin: [0, 0, 0, 10],
        // });
    }
    return nodes;
};